import React, { useState } from 'react';
import classNames from 'classnames';
import { arrayOf, func, node, shape, string } from 'prop-types';
import css from './AccordionCategory.module.css';

const AccordionCategory = props => {
  const {
    category,
    selectedKeys,
    onToggleKey,
    bodyFooter,
    accordionItemClassName,
    accordionHeaderClassName,
    accordionHeaderOpenClassName,
    accordionLabelClassName,
    selectedBadgeClassName,
    accordionChevronClassName,
    accordionBodyClassName,
    skillLabelClassName,
    skillCheckboxClassName,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const selectedCount = (category.skills || []).filter(s => selectedKeys.includes(s.key)).length;

  return (
    <div className={classNames(css.accordionItem, accordionItemClassName)}>
      <button
        type="button"
        className={classNames(css.accordionHeader, accordionHeaderClassName, {
          [css.accordionHeaderOpen]: isOpen,
          [accordionHeaderOpenClassName]: isOpen,
        })}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className={classNames(css.accordionLabel, accordionLabelClassName)}>
          {category.label}
          {selectedCount > 0 ? (
            <span className={classNames(css.selectedBadge, selectedBadgeClassName)}>{selectedCount}</span>
          ) : null}
        </span>
        <span className={classNames(css.accordionChevron, accordionChevronClassName)}>
          {isOpen ? '▲' : '▼'}
        </span>
      </button>

      {isOpen ? (
        <div className={classNames(css.accordionBody, accordionBodyClassName)}>
          {(category.skills || []).map(skill => {
            const { key, label } = { ...skill };
            return (
              <label key={key} className={classNames(css.skillLabel, skillLabelClassName)}>
                <input
                  type="checkbox"
                  className={classNames(css.skillCheckbox, skillCheckboxClassName)}
                  checked={selectedKeys.includes(key)}
                  onChange={() => onToggleKey(key)}
                />
                <span>{label}</span>
              </label>
            );
          })}
          {bodyFooter}
        </div>
      ) : null}
    </div>
  );
};

AccordionCategory.defaultProps = {
  bodyFooter: null,
  accordionItemClassName: null,
  accordionHeaderClassName: null,
  accordionHeaderOpenClassName: null,
  accordionLabelClassName: null,
  selectedBadgeClassName: null,
  accordionChevronClassName: null,
  accordionBodyClassName: null,
  skillLabelClassName: null,
  skillCheckboxClassName: null,
};

AccordionCategory.propTypes = {
  category: shape({
    key: string.isRequired,
    label: string.isRequired,
    skills: arrayOf(
      shape({
        key: string.isRequired,
        label: string.isRequired,
      })
    ),
  }).isRequired,
  selectedKeys: arrayOf(string).isRequired,
  onToggleKey: func.isRequired,
  bodyFooter: node,
  accordionItemClassName: string,
  accordionHeaderClassName: string,
  accordionHeaderOpenClassName: string,
  accordionLabelClassName: string,
  selectedBadgeClassName: string,
  accordionChevronClassName: string,
  accordionBodyClassName: string,
  skillLabelClassName: string,
  skillCheckboxClassName: string,
};

export default AccordionCategory;
